export default __webpack_public_path__ + "static/media/assignment.47078c06.svg";